import axios, { AxiosError } from "axios";
import {
  DefaultPaymentInstrumentPayload,
  CreditCardDetails,
  PaymentInstrumentValidationData,
  SavePaymentInstrumentPayload,
  SaveCreditCardResponse,
} from "../../types/PaymentTypes";
import * as AppSettingsService from "../AppSettingsService";

const appSettings = AppSettingsService;

export async function validatePaymentInstrumentByPaymentGateway(
  data: PaymentInstrumentValidationData
): Promise<any> {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/common/Payments/v1/PaymentInstrument/Validate`,
      data
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function validatePaymentInstrumentByPaymentInstrumentId(
  paymentInstrumentId: number,
  personId: number
): Promise<any> {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/common/Payments/v1/PaymentInstrument/Validate/${paymentInstrumentId}`,
      { headers: { "x-personId": personId } }
    );
    return {
      data: response.data,
      status: response.status,
    };
  } catch (error: any) {
    if (error?.response?.status === 404) {
      return {
        data: error.response.data,
        status: error.response.status,
      };
    }
    throw error;
  }
}

export async function deletePaymentInstrument(
  paymentInstrumentId: number,
  personId: number
): Promise<any> {
  try {
    const response = await axios.delete(
      `${appSettings.getAppApiUrl()}/common/Payments/v1/PaymentInstrument/Default/${paymentInstrumentId}`,
      { headers: { "x-personId": personId } }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getDefaultSavedPaymentInstrument(
  params: DefaultPaymentInstrumentPayload
): Promise<{
  data?: CreditCardDetails;
  status: number;
}> {
  try {
    const baseUrl = `${appSettings.getAppApiUrl()}/common/Payments/v1/PaymentInstrument/Default`;
    const response = await axios.get(baseUrl, { params });
    return {
      data: response.data,
      status: response.status,
    };
  } catch (error: any) {
    if (error?.response?.status === 404) {
      return {
        status: 404,
      };
    }
    throw error;
  }
}

export const getPaymentInstrumentByPaymentInstrumentId = async (
  paymentInstrumentId: number
) => {
  try {
    const baseUrl = `${appSettings.getAppApiUrl()}/common/Payments/v1/PaymentInstrument/${paymentInstrumentId}`;
    const response = await axios.get(baseUrl);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export async function savePaymentInstrument(
  data: SavePaymentInstrumentPayload
): Promise<{
  data: SaveCreditCardResponse;
  status: number;
}> {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/common/Payments/v1/PaymentInstrument`,
      data
    );
    return {
      data: response.data,
      status: response.status,
    };
  } catch (error: any) {
    if (error?.response) {
      return {
        data: error.response.data,
        status: error.response.status,
      };
    }
    throw error;
  }
}
